import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Input from "@mui/material/Input";
import InputLabel from "@mui/material/InputLabel";
import IconButton from "@mui/material/IconButton";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";

import { signIn } from "actions";

const SignIn = () => {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  // const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setValues((prevState) => ({ ...values, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      signIn(values, ({ type, res }) => {
        switch (type) {
          case "Error":
            enqueueSnackbar(res + "", { variant: "error" });
            break;

          case "User":
            reDirect();
            break;
          default:
            break;
        }
      })
    );
  };
  const reDirect = () => {
    if (history.location.pathname !== "/") {
      history.push(history.location.pathname);
    } else {
      history.push("/main");
    }
  };
  // const validate = (e) => {
  //   const { name, value } = e.target;
  //   // eslint-disable-next-line
  //   const validEmail =
  //     /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
  //   switch (name) {
  //     case "email":
  //       if (!value.match(validEmail)) {
  //         setErrors((prevState) => ({
  //           ...prevState.errors,
  //           [name]: "Email format invaild",
  //         }));
  //       } else {
  //         setErrors((prevState) => ({
  //           ...prevState.errors,
  //           [name]: "",
  //         }));
  //       }
  //       break;
  //     default:
  //       break;
  //   }
  // };
  return (
    <Box
      component="main"
      sx={{
        width: "auto",
        maxWidth: 400,
        marginLeft: (theme) => theme.spacing(3),
        marginRight: (theme) => theme.spacing(3),
        [`@media (min-width:448px)`]: {
          width: 400,
          marginLeft: "auto",
          marginRight: "auto",
        },
      }}
    >
      <Paper
        sx={{
          marginTop: (theme) => theme.spacing(8),
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: (theme) =>
            `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)}`,
        }}
      >
        <IconButton
          sx={{
            backgroundColor: "primary.main",
            height: 44,
            width: 44,
          }}
        >
          <Avatar
            sx={{
              margin: (theme) => theme.spacing(1),
              backgroundColor: "secondary.main",
              color: "primary.main",
            }}
          >
            <LockOutlinedIcon />
          </Avatar>
        </IconButton>
        <Typography component="h1" variant="h5" color="primary">
          Gulf-Pro Module
        </Typography>
        <Box
          component="form"
          onSubmit={(e) => handleSubmit(e)}
          sx={{
            marginTop: (theme) => theme.spacing(2),
            marginLeft: (theme) => theme.spacing(3),
            marginRight: (theme) => theme.spacing(3),
            marginBottom: (theme) => theme.spacing(3),
          }}
        >
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="email">Email Address</InputLabel>
            <Input
              id="email"
              name="email"
              autoComplete="email"
              autoFocus
              value={values.email}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              name="password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={values.password}
              onChange={handleChange}
            />
          </FormControl>
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ marginTop: (theme) => theme.spacing(4) }}
          >
            Sign in
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SignIn;
